// Advisory Multi-Goal, Multi-Portfolio template (QP-150)
export { advisoryMultiPortfolioStandard } from "./advisory-multi-portfolio";
